import React from "react";
import { Table, Divider, Popconfirm, Space, Image } from "antd";
import { useTranslation } from "react-i18next";

import ApiConstants from "../../../api/ApiConstants";

import Edit from "../../../public/images/dashboard/tables/edit.svg";
import Delete from "../../../public/images/dashboard/tables/delete.svg";

import "../../../public/sass/layout/_index.scss";

const InvestmentFondsTable = ({ loading, deleteFond, getFondById, fonds }) => {
  const [t, i18n] = useTranslation();
  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      width: 50,
      render: (text, record, index) => {
        return (
          <>
            {index+1}
          </>
        )
      }
    },
    {
      title: "Image",
      dataIndex: "image_name",
      key: "image_name",
      render: (img) => (
        <>
          <Image src={ApiConstants.IMAGE_URL + img} width={100} />
        </>
      ),
    },
    {
      title: "Headline",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Subtitle",
      dataIndex: "subtitle",
      key: "subtitle",
    },
    {
      title: "Is Placed",
      dataIndex: "is_placed",
      key: "is_placed",
      render: (e) => (
        <>
          <p>{e == 1 ? 'Yes' : 'No'}</p>
        </>
      )
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      width: 100,
      render: (e) => (
        <Space size="middle">
          <a onClick={() => getFondById(e?.id)}>
            <img src={Edit} alt="Edit" />
          </a>
          <Popconfirm
            title={t("are_you_sure")}
            onConfirm={() => deleteFond(e?.id)}
          >
            <a>
              <img src={Delete} alt="Delete" />
            </a>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Divider />
      <Table
        loading={loading}
        columns={columns}
        className="table"
        dataSource={fonds}
        scroll={{ y: ApiConstants.TABLE_HEIGHT }}
      />
    </div>
  );
};
export default InvestmentFondsTable;
